import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "user-form" }
const _hoisted_2 = { class: "form-item" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = {
  key: 0,
  class: "form-popup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserActionPopup = _resolveComponent("UserActionPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "name" }, "Name", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          required: "",
          placeholder: _ctx.userInfo.name,
          class: _normalizeClass({ 'error-input': _ctx.nameError })
        }, null, 10, _hoisted_3), [
          [_vModelText, _ctx.form.name]
        ]),
        (_ctx.nameError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.nameError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "email" }, "Email ", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
          required: "",
          placeholder: _ctx.userInfo.email,
          class: _normalizeClass({ 'error-input': _ctx.emailError })
        }, null, 42, _hoisted_6), [
          [_vModelText, _ctx.form.email]
        ]),
        (_ctx.emailError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.emailError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "age" }, "Age", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          id: "age",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.age) = $event)),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateAge && _ctx.validateAge(...args))),
          required: "",
          placeholder: _ctx.userInfo.age,
          class: _normalizeClass({ 'error-input': _ctx.ageError })
        }, null, 42, _hoisted_9), [
          [_vModelText, _ctx.form.age]
        ]),
        (_ctx.ageError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.ageError), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "submit" }, [
        _createElementVNode("button", {
          class: "submit-button",
          type: "submit"
        }, "Send")
      ], -1))
    ], 32),
    (_ctx.isSubmit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_UserActionPopup, {
            question: "Saving changes?",
            onSetSubmit: _ctx.setSubmit,
            onCancelSubmit: _ctx.cancelSubmit
          }, null, 8, ["onSetSubmit", "onCancelSubmit"])
        ]))
      : _createCommentVNode("", true)
  ]))
}